import { NoteMessage } from '@/@types/messages/NoteMessage'
import { UpdateOrderPartMessage } from '@/@types/messages/UpdateOrderPartMessage'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'
import { ObjectCreatedResponse } from '@/@types/responses/common/ObjectCreatedResponse'
import { UpdateOrderPartsMessage } from '@/@types/messages/UpdateOrderPartsMessage'

export class OrderPartService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public createOrderPartNote(orderPartId: number, noteMessage: NoteMessage): Promise<ObjectCreatedResponse<number>> {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(noteMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/order-parts/${orderPartId}/notes`, this.miscellaneousService, requestOptions).then(async response => {
      const json = await response.json()
      return new ObjectCreatedResponse<number>(json.id)
    })
  }

  public deleteOrderPart(id: number): Promise<void> {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/order-parts/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateOrderPart(orderPartId: number, updateOrderPartMessage: UpdateOrderPartMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateOrderPartMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/order-parts/${orderPartId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateOrderParts(updateOrderPartsMessage: UpdateOrderPartsMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateOrderPartsMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/order-parts`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}